export const GET_HOTEL_REQUEST = "GET_HOTEL_REQUEST"
export const GET_HOTEL_SUCESS = "GET_HOTEL_SUCESS"
export const GET_HOTEL_ERROR = "GET_HOTEL_ERROR"

export const FILTER_HOTEL_REQUEST = "FILTER_HOTEL_REQUEST"
export const FILTER_HOTEL_SUCESS = "FILTER_HOTEL_SUCESS"
export const FILTER_HOTEL_ERROR = "FILTER_HOTEL_ERROR"

export const Add_HOTEL_REQUEST = "ADD_HOTEL_REQUEST"

